export default {
    'name': 'square-big',
    'width': '48',
    'height': '48',
    'viewBox': '0 0 48 48',
    'data': '<rect x=\'20\' y=\'20\' width=\'8\' height=\'8\' fill=\'#006CFD\'/>'
}
